(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beneficios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chilly-beneficios')) {
    customElements.define(
      'chilly-beneficios',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-list]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.hint = this.querySelector('[data-hint]');
          if (!this.list || !this.prev || !this.next) return;

          this.motion = this.dataset.motion || 'none';
          this.speed = Math.max(1, Number(this.dataset.speed) || 4);
          this.mobileOnly = this.dataset.mobileOnly === 'true';
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.paused = false;
          this.holdUntil = 0;

          this.update = this.update.bind(this);
          this.refresh = this.refresh.bind(this);

          this.prev.addEventListener('click', () => this.move(-1));
          this.next.addEventListener('click', () => this.move(1));
          this.list.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.refresh);

          this.addEventListener('pointerenter', () => this.pause());
          this.addEventListener('pointerleave', () => this.resume());
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', () => this.resume());
          this.addEventListener(
            'pointerdown',
            () => {
              this.holdUntil = Date.now() + 5000;
              this.pause();
            },
            { passive: true }
          );

          this.refresh();
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.refresh);
          clearInterval(this.timer);
          clearTimeout(this.resumeTimer);
        }

        /* Decide qué movimiento corresponde según la configuración y el ancho de pantalla */
        refresh() {
          const active =
            this.motion !== 'none' &&
            !this.reducedQuery.matches &&
            (!this.mobileOnly || this.mobileQuery.matches);
          const mode = active ? this.motion : 'none';

          if (mode === 'marquee') {
            this.startMarquee();
          } else {
            this.stopMarquee();
          }

          if (mode === 'auto') {
            this.startAuto();
          } else {
            this.stopAuto();
          }

          this.update();
        }

        pause() {
          this.paused = true;
          this.classList.add('is-paused');
        }

        resume() {
          const wait = Math.max(0, this.holdUntil - Date.now());
          clearTimeout(this.resumeTimer);
          this.resumeTimer = setTimeout(() => {
            this.paused = false;
            this.classList.remove('is-paused');
          }, wait);
        }

        /* Avance automático: pasa de a una tarjeta y vuelve al inicio al llegar al final */
        startAuto() {
          this.classList.add('is-carousel');
          if (!this.timer) {
            this.timer = setInterval(() => this.step(), this.speed * 1000);
          }
        }

        stopAuto() {
          this.classList.remove('is-carousel');
          clearInterval(this.timer);
          this.timer = null;
        }

        step() {
          /* No avanza si hay un cartel emergente abierto dentro de una tarjeta */
          if (this.paused || document.hidden || this.querySelector('dialog[open]')) return;

          const max = this.list.scrollWidth - this.list.clientWidth;
          if (max <= 4) return;

          if (this.list.scrollLeft >= max - 4) {
            this.list.scrollTo({ left: 0, behavior: 'smooth' });
            return;
          }

          const first = this.list.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
          const distance = first ? first.getBoundingClientRect().width + gap : this.list.clientWidth;
          this.list.scrollBy({ left: distance, behavior: 'smooth' });
        }

        /* Marquesina: duplica las tarjetas una vez y las mueve en forma continua */
        startMarquee() {
          if (!this.classList.contains('is-marquee')) {
            Array.from(this.list.children).forEach((item) => {
              const clone = item.cloneNode(true);
              [clone, ...clone.querySelectorAll('*')].forEach((element) => {
                Array.from(element.attributes).forEach((attribute) => {
                  if (attribute.name === 'id' || attribute.name.startsWith('data-shopify')) {
                    element.removeAttribute(attribute.name);
                  }
                });
              });
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('data-clone', '');
              clone.querySelectorAll('a, button').forEach((element) => element.setAttribute('tabindex', '-1'));
              this.list.appendChild(clone);
            });
            this.list.scrollLeft = 0;
            this.classList.add('is-marquee');
          }

          const columns = Number(this.mobileQuery.matches ? this.dataset.colsMobile : this.dataset.cols) || 1;
          const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
          const viewportWidth = this.list.parentElement.clientWidth;
          const count = this.list.querySelectorAll(':scope > :not([data-clone])').length;
          const itemWidth = Math.max(120, (viewportWidth - gap * columns) / (columns + 0.2));

          this.style.setProperty('--ben-item-px', `${itemWidth}px`);
          this.style.setProperty('--ben-marquee-duration', `${Math.max(1, count) * this.speed}s`);
        }

        stopMarquee() {
          if (!this.classList.contains('is-marquee')) return;

          this.list.querySelectorAll(':scope > [data-clone]').forEach((clone) => clone.remove());
          this.classList.remove('is-marquee');
          this.style.removeProperty('--ben-item-px');
          this.style.removeProperty('--ben-marquee-duration');
        }

        move(direction) {
          this.list.scrollBy({ left: direction * this.list.clientWidth * 0.9, behavior: 'smooth' });
        }

        update() {
          if (this.classList.contains('is-marquee')) {
            this.prev.hidden = true;
            this.next.hidden = true;
            if (this.hint) this.hint.hidden = true;
            return;
          }

          const max = this.list.scrollWidth - this.list.clientWidth;
          const scrollable = max > 4;
          this.prev.hidden = !scrollable || this.list.scrollLeft <= 4;
          this.next.hidden = !scrollable || this.list.scrollLeft >= max - 4;
          if (this.hint) this.hint.hidden = !scrollable || this.list.scrollLeft > 20;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
